import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const login = async (bodyParams: any) => {
  return apiClient(endpoints.auth.login, {
    method: "POST",
    body: JSON.stringify(bodyParams),
  });
};

export const register = async (bodyParams: any) => {
  return apiClient(endpoints.auth.register, {
    method: "POST",
    body: JSON.stringify(bodyParams),
  });
};

export const resetPassword = async (bodyParams: any) => {
  return apiClient(endpoints.auth.resetPassword, {
    method: "POST",
    body: JSON.stringify(bodyParams),
  });
};

export const changePassword = async (bodyParams: any) => {
  return apiClient(endpoints.auth.changePassword, {
    method: "POST",
    body: JSON.stringify(bodyParams),
  });
};

export const confirmResetPassword = async (bodyParams: any) => {
  return apiClient(endpoints.auth.resetPasswordConfirm, {
    method: "POST",
    body: JSON.stringify(bodyParams),
  });
};

export const verifyUser = async (bodyParams: any) => {
  return apiClient(endpoints.auth.userVerify, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};

export const resendVerificationCode = async (username) => {
  return apiClient(endpoints.auth.resendVerificationCode, {
    method: "POST",
    body: JSON.stringify({
      username: username,
    }),
  });
};

export const getUserProfile = async (accessToken?: string) => {
  const bodyParams = {
    accessToken,
  };
  return apiClient(endpoints.auth.userProfile, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};
export const createStripeAccount = async (accessToken?: string) => {
  const bodyParams = {
    accessToken,
  };
  return apiClient(endpoints.auth.createStripeAccount, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};
export const redeemBalance = async (accessToken?: string, amount?: number) => {
  const bodyParams = {
    accessToken,
    amount,
  };
  return apiClient(endpoints.auth.redeemBalance, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};
export const getOtherUserProfile = async (username?: string) => {
  return apiClient(endpoints.auth.otherUserProfile, {
    method: "POST",
    body: JSON.stringify({
      body: {
        username: username,
      },
    }),
  });
};

export const logoutUser = async (bodyParams: any) => {
  return apiClient(endpoints.auth.logout, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};

export const getBalance = async (accessToken: string) => {
  const bodyParams = {
    accessToken,
  };

  return apiClient(endpoints.auth.balance, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
  });
};

export const updateUserProfile = async (params: any) => {
  return apiClient(endpoints.auth.updateProfile, {
    method: "PATCH",
    body: JSON.stringify({
      body: params,
    }),
  });
};
export const blockUser = async (params: any) => {
  return apiClient(endpoints.auth.blockUser, {
    method: "POST",
    body: JSON.stringify({
      body: params,
    }),
  });
};
export const uploadToS3 = async (params: any) => {
  return apiClient(endpoints.auth.uploadToS3, {
    method: "POST",
    body: JSON.stringify({
      body: params,
    }),
  });
};

export const updateUserGames = async (params: any) => {
  return apiClient(endpoints.auth.updateGenre, {
    method: "PATCH",
    body: JSON.stringify({
      body: params,
    }),
  });
};

export const fetchGenreGames = async () => {
  return apiClient(endpoints.auth.getGenreGames, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const fetchLiveNowGames = async () => {
  return apiClient(endpoints.auth.getLiveNowGames, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getObsConnection = async (accessToken: string) => {
  const url = `${endpoints.auth.getObsConnection}?accessToken=${accessToken}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const storeObsConnection = async (params: any) => {
  return apiClient(endpoints.auth.storeObsConnection, {
    method: "POST",
    body: JSON.stringify(params),
  });
};
export const updateObsConnection = async (params: any) => {
  return apiClient(endpoints.auth.updateObsConnection, {
    method: "POST",
    body: JSON.stringify(params),
  });
};
export const getReferral = async (params: any) => {
  return apiClient(endpoints.auth.getReferral, {
    method: "POST",
    body: JSON.stringify({ body: params }),
  });
};

export const getReferralSession = async (
  accessToken: string,
  eventId?: string,
  shareType?: string,
  createTracking?: boolean
) => {
  let url = `${endpoints.auth.getReferral}?accessToken=${accessToken}`;
  if (eventId) {
    url += `&eventId=${eventId}`;
  }
  if (shareType) {
    url += `&shareType=${shareType}`;
  }
  if (createTracking) {
    url += `&createTracking=true`;
  }
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const checkUserRole = async (accessToken: string) => {
  const url = `${endpoints.auth.checkRole}?accessToken=${accessToken}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const claimDailyCheckInReward = async (params: any) => {
  return apiClient(endpoints.auth.claimDailyCheckInReward, {
    method: "POST",
    body: JSON.stringify({ accessToken: params }),
  });
};

export const getShortUrl = async (eventId: string, shareType?: string) => {
  let url = `${endpoints.events.getShortUrl}?eventId=${eventId}`;
  if (shareType) {
    url += `&shareType=${shareType}`;
  }
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getShortUrlData = async (shortCode: string, ref?: string) => {
  let url = `${endpoints.events.getShortUrlData}?shortCode=${shortCode}`;
  if (ref) {
    url += `&ref=${ref}`;
  }
  console.log("getShortUrlData - Calling API with URL:", url);
  console.log("getShortUrlData - Parameters:", { shortCode, ref });
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
